export const routes = {
  account: '/account',
  accountSetting: '/setting',
  accountMembership: '/membership',
  accountBilling: '/billing',
  accountNotification: '/notification',
  accountConnection: '/connection',
  accountSecurity: '/security',
  accountFAQ: '/faq',
};
